<template>
  <div class="solidity-contract-detector  contract-detector">
    <common-bg-plate>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane v-if="$utils.hasAuth($store, auth.contractdetector.solidity.contractManage)" label="合约管理" name="contract">
          <action-bar>
            <search
              v-model="contractKey"
              placeholder="请输入ID/合约名"
              @onSearch="onSearchContracts"
            ></search>
            <btn-style :btn-list="cBtnList"></btn-style>
            <div class="fill"></div>
          </action-bar>
          <solidity-contract-list
            ref="contract"
            @goDetail="onGoContractDetail"
            @popEditModel="onPopEditModel"
            @popConfirmDelete="onPopConfirmDelete"
          ></solidity-contract-list>
        </el-tab-pane>
        <el-tab-pane v-if="$utils.hasAuth($store, auth.contractdetector.solidity.taskManage)" label="任务管理" name="task">
          <action-bar>
            <search
              v-model="taskKey"
              placeholder="请输入合约ID/合约名"
              @onSearch="onSearchTasks"
            ></search>
            <btn-style :btn-list="tBtnList"></btn-style>
            <div class="fill"></div>
            <el-checkbox v-model="onlyUnfinished" class="action-bar-checkbox" @change="onShowModeChanged"
              >只看未完成</el-checkbox>
            <btn-style :btn-list="tBtnList2"></btn-style>
          </action-bar>
          <solidity-task-list
            ref="task"
            @goDetail="onGoTaskDetail"
            @popConfirmRestart="onPopConfirmRestart"
          ></solidity-task-list>
        </el-tab-pane>
      </el-tabs>
    </common-bg-plate>
    <add-solidity-contract
      :dialog-visible.sync="showAddSolidityContract"
      @addSuccess="onAddContractSuccess"
    ></add-solidity-contract>
    <modify-solidity-contract
      :contract-info="contractInfo"
      :dialog-visible.sync="showEditSolidityContract"
      @editSuccess="onEditContractSuccess"
    ></modify-solidity-contract>
    <delete-solidity-contract
      :contract-info="contractInfo"
      :dialog-visible.sync="showDeleteSolidityContract"
      @deleteSuccess="onDeleteContractSuccess"
    ></delete-solidity-contract>
    <restart-solidity-detector-task
      :task-info="taskInfo"
      :dialog-visible.sync="showRestartSolidityDetectorTask"
      @restartSuccess="onRestartTaskSuccess"
    ></restart-solidity-detector-task>
    <create-solidity-detector-task
      :dialog-visible.sync="showCreateSolidityDetectorTask"
      @createSuccess="onCreateTaskSuccess"
    ></create-solidity-detector-task>
  </div>
</template>

<script>
import auth from '@/auth/index'
import { mapState, mapActions } from 'vuex'
import solidityContractList from './components/solidityContractList'
import solidityTaskList from './components/solidityTaskList'
import addSolidityContract from './addSolidityContract'
import deleteSolidityContract from './deleteSolidityContract'
import modifySolidityContract from './modifySolidityContract'
import restartSolidityDetectorTask from './restartSolidityDetectorTask'
import createSolidityDetectorTask from './createSolidityDetectorTask'

export default {
  name: 'SolidityContractDetector',
  components: {
    solidityContractList,
    solidityTaskList,
    addSolidityContract,
    modifySolidityContract,
    deleteSolidityContract,
    restartSolidityDetectorTask,
    createSolidityDetectorTask
  },
  data() {
    return {
      activeName: 'contract',
      contractKey: '',
      taskKey: '',
      onlyUnfinished: false,
      showAddSolidityContract: false,
      showEditSolidityContract: false,
      showDeleteSolidityContract: false,
      contractInfo: {
        ID: '',
        Filename: '',
        TaskCount: 0,
        Type: '',
        SolcVersion: '',
        CreatedAt: 0,
        UpdatedAt: 0
      },
      showCreateSolidityDetectorTask: false,
      showRestartSolidityDetectorTask: false,
      taskInfo: {
        ID: '',
        ContractID: '',
        ContractFilename: '',
        Status: 0,
        CreatedAt: 0,
        StartedAt: 0,
        FinishedAt: 0
      },
      cBtnList: [
        {
          btnContent: '上传合约',
          click: () => {
            return this.onUploadContract()
          },
          icon: 'icon-gen',
          auth: auth.contractdetector.solidity.contractManage.upload
        }
      ],
      tBtnList: [
        {
          btnContent: '创建任务',
          click: () => {
            return this.onCreateTask()
          },
          icon: 'icon-gen',
          auth: auth.contractdetector.solidity.taskManage.create
        }
      ],
      tBtnList2: [
        {
          btnContent: '刷新',
          click: () => {
            return this.onRefreshTaskList()
          },
          icon: 'icon-refresh',
          type: 'default',
          auth: auth.contractdetector.solidity.taskManage.refresh
        }
      ],
      auth: auth
    }
  },

  computed: {
    ...mapState({
      solidityPageTab: state => state.contractdetector.solidityTab
    })
  },
  mounted() {
    this.activeName = this.solidityPageTab
    this.$refs[this.activeName]?.refresh(
      this.activeName == 'contract' ? this.contractKey : this.taskKey,
      this.onlyUnfinished
    )
  },
  methods: {
    ...mapActions(['setSolidityPageTab']),
    handleClick(tab) {
      this.$refs[tab.name]?.refresh(
        tab.name == 'contract' ? this.contractKey : this.taskKey,
        this.onlyUnfinished
      )
      this.setSolidityPageTab(tab.name)
    },
    onUploadContract() {
      this.showAddSolidityContract = true
    },
    onSearchContracts(keywords) {
      this.onRefreshContractList()
    },
    onAddContractSuccess() {
      this.onRefreshContractList()
    },
    onEditContractSuccess() {
      this.onRefreshContractList()
    },
    onDeleteContractSuccess() {
      this.onRefreshContractList()
    },
    onRefreshContractList() {
      this.$refs.contract.refresh(this.contractKey)
    },
    onGoContractDetail(row) {
      this.contractInfo = row
      this.$router.push({
        name: 'solidityContractDetail',
        query: {
          contractId: this.contractInfo.ID
        }
      })
    },
    onPopEditModel(row) {
      this.contractInfo = row
      this.showEditSolidityContract = true
    },
    onPopConfirmDelete(row) {
      this.contractInfo = row
      this.showDeleteSolidityContract = true
    },
    onGoTaskDetail(row) {
      this.taskInfo = row
      this.$router.push({
        name: 'solidityTaskDetail',
        query: {
          taskId: this.taskInfo.ID
        }
      })
    },
    onPopConfirmRestart(row) {
      this.taskInfo = row
      this.showRestartSolidityDetectorTask = true
    },
    onCreateTask() {
      this.showCreateSolidityDetectorTask = true
    },
    onSearchTasks() {
      this.onRefreshTaskList()
    },
    onRefreshTaskList() {
      this.$refs.task.refresh(this.taskKey, this.onlyUnfinished)
    },
    onCreateTaskSuccess() {
      this.onRefreshTaskList()
    },
    onRestartTaskSuccess() {
      this.onRefreshTaskList()
    },
    onShowModeChanged() {
      this.onRefreshTaskList()
    }
  }
}
</script>

<style scoped lang="scss">
.solidity-contract-detector {
  min-height: var(--base-main-router-body-avaliable-height);

  .action-bar-checkbox {
    margin-right: var(--base-size-16);
    line-height: var(--base-size-32);
  }
}
</style>
